// カラーピッカーブロック（旧ビルダープレビュー blocks/colour.ts から復元）
// if_color / while_color の COLOUR 入力に挿す shadow ブロック。

import Blockly from "blockly";
import BlocklyJs from "blockly/javascript";

export const InitColourBlock = () => {
  const colourPickerBlock = () => ({
    type: "colour_picker_internal",
    message0: "%1",
    args0: [
      {
        type: "field_colour",
        name: "COLOUR",
        colour: "#71cdfc",
        colourOptions: ["#71cdfc", "#fb3a69", "#fdd73e"],
        colourTitles: ["blue", "red", "yellow"],
        columns: 1,
        style: "colour_blocks",
      },
    ],
    output: "Colour",
  });
  Blockly.Blocks["colour_picker_internal"] = {
    init: function () {
      this.jsonInit(colourPickerBlock());
      this.contextMenu = false;
    },
  };

  BlocklyJs["colour_picker_internal"] = function (block: Blockly.Block) {
    const colour = block.getFieldValue("COLOUR");
    return [`"${colour}"`, (BlocklyJs as unknown as { ORDER_NONE: number }).ORDER_NONE];
  };
};
